import api from '../utils/api';

class ConfigAPI {
    // ==================== PERMISSÕES ====================

    async getAllPermissions() {
        const response = await api.get('/permissions');
        return response.data;
    }

    async getPermissionsMatrix() {
        const response = await api.get('/permissions/matrix');
        return response.data;
    }

    async getPermissionById(id) {
        const response = await api.get(`/permissions/${id}`);
        return response.data;
    }

    async createPermission(data) {
        const response = await api.post('/permissions', data);
        return response.data;
    }

    async updatePermission(id, data) {
        const response = await api.put(`/permissions/${id}`, data);
        return response.data;
    }

    async deletePermission(id) {
        const response = await api.delete(`/permissions/${id}`);
        return response.data;
    }

    async updateResourcePermission(permissionId, resourceName, hasAccess) {
        const response = await api.patch(`/permissions/${permissionId}/resources`, {
            resourceName,
            hasAccess
        });
        return response.data;
    }

    async createDefaultPermissions() {
        const response = await api.post('/permissions/defaults');
        return response.data;
    }

    // ==================== RECURSOS ====================

    async createResource(data) {
        const response = await api.post('/permissions/resources', data);
        return response.data;
    }

    async updateResource(key, data) {
        const response = await api.put(`/permissions/resources/${key}`, data);
        return response.data;
    }

    async deleteResource(key) {
        const response = await api.delete(`/permissions/resources/${key}`);
        return response.data;
    }

    // ==================== CONFIGURAÇÕES GLOBAIS ====================

    async getConfig() {
        const response = await api.get('/config');
        return response.data;
    }

    async updateGeneralConfig(data) {
        const response = await api.put('/config/general', data);
        return response.data;
    }

    async updateSecurityConfig(data) {
        const response = await api.put('/config/security', data);
        return response.data;
    }

    // ==================== COLUNAS POWER BI ====================

    async getPowerBIColumns() {
        const response = await api.get('/config/powerbi/columns');
        return response.data;
    }

    async addPowerBIColumn(data) {
        const response = await api.post('/config/powerbi/columns', data);
        return response.data;
    }

    async updatePowerBIColumn(id, data) {
        const response = await api.put(`/config/powerbi/columns/${id}`, data);
        return response.data;
    }

    async deletePowerBIColumn(id) {
        const response = await api.delete(`/config/powerbi/columns/${id}`);
        return response.data;
    }

    async resetPowerBIColumns() {
        const response = await api.post('/config/powerbi/reset');
        return response.data;
    }

    // ==================== COLUNAS ICS ====================

    async getICSColumns() {
        const response = await api.get('/config/ics/columns');
        return response.data;
    }

    async addICSColumn(data) {
        const response = await api.post('/config/ics/columns', data);
        return response.data;
    }

    async updateICSColumn(id, data) {
        const response = await api.put(`/config/ics/columns/${id}`, data);
        return response.data;
    }

    async deleteICSColumn(id) {
        const response = await api.delete(`/config/ics/columns/${id}`);
        return response.data;
    }

    async resetICSColumns() {
        const response = await api.post('/config/ics/reset');
        return response.data;
    }


    // ==================== FILTROS DE TIPO DE SERVIÇO ====================

    async getServiceTypeFilters() {
        const response = await api.get('/config/service-type-filters');
        return response.data;
    }

    async addServiceTypeFilter(data) {
        const response = await api.post('/config/service-type-filters', data);
        return response.data;
    }

    async updateServiceTypeFilter(id, data) {
        const response = await api.put(`/config/service-type-filters/${id}`, data);
        return response.data;
    }

    async deleteServiceTypeFilter(id) {
        const response = await api.delete(`/config/service-type-filters/${id}`);
        return response.data;
    }

    async resetServiceTypeFilters() {
        const response = await api.post('/config/service-type-filters/reset');
        return response.data;
    }

    // ==================== STATUS CONFIG ====================
    async getStatusConfigs() {
        try {
            const response = await api.get('/config/status');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar status configs:', error);
            throw error;
        }
    };

    async addStatusConfig(data) {
        try {
            const response = await api.post('/config/status', data);
            return response.data;
        } catch (error) {
            console.error('Erro ao adicionar status config:', error);
            throw error;
        }
    };

    async updateStatusConfig(id, data) {
        try {
            const response = await api.put(`/config/status/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar status config:', error);
            throw error;
        }
    };

    async deleteStatusConfig(id) {
        try {
            const response = await api.delete(`/config/status/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar status config:', error);
            throw error;
        }
    };

    async resetStatusConfigs() {
        try {
            const response = await api.post('/config/status/reset');
            return response.data;
        } catch (error) {
            console.error('Erro ao resetar status configs:', error);
            throw error;
        }
    };

    // ==================== IGNORED STATUS ====================
    async getIgnoredStatus() {
        try {
            const response = await api.get('/config/ignored-status');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar ignored status:', error);
            throw error;
        }
    };

    async addIgnoredStatus(data) {
        try {
            const response = await api.post('/config/ignored-status', data);
            return response.data;
        } catch (error) {
            console.error('Erro ao adicionar ignored status:', error);
            throw error;
        }
    };

    async updateIgnoredStatus(id, data) {
        try {
            const response = await api.put(`/config/ignored-status/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar ignored status:', error);
            throw error;
        }
    };

    async deleteIgnoredStatus(id) {
        try {
            const response = await api.delete(`/config/ignored-status/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao deletar ignored status:', error);
            throw error;
        }
    };

    async resetIgnoredStatus() {
        try {
            const response = await api.post('/config/ignored-status/reset');
            return response.data;
        } catch (error) {
            console.error('Erro ao resetar ignored status:', error);
            throw error;
        }
    };

}

export default new ConfigAPI();